const MusicPlayTimes = {
    OnLevel: 0,
    OnScreen: 64,
    OnTitle: 101,
    OnEndScreen: 102,
    OnCreditsScreen: 103,
    Unused: 255
}

const niceNames = {
    0: "On Level",
    64: "On Screen",
    101: "On Title Screen",
    102: "On Ending Screen",
    103: "On Credits Screen",
    255: "Unused"
};

export default MusicPlayTimes;

export function getMusicPositionFromKey(key) {
    return Object.keys(MusicPlayTimes).find(k => MusicPlayTimes[k] === key);
}

export function getMusicPositionName(key) {

    return niceNames[key] ?? niceNames[MusicPlayTimes[key]];
}

export function getMusicShowAtDetail(key, detail, screens) {
    let value = niceNames[key];
    if (key < 64) {
        return value + ' ' + (detail + 1);
    } else if (key < 100) {
        let theScreen = null;
        if (screens && screens.length) {
            theScreen = screens.find(a => a.id === detail)
        }
        if (theScreen) {
            value += ' (' + theScreen.title + ')';
        }
    }
    return value;
}